import { render } from "./CoursesCarousel.vue?vue&type=template&id=6d9ae6d3&scoped=true"
import script from "./CoursesCarousel.vue?vue&type=script&lang=js"
export * from "./CoursesCarousel.vue?vue&type=script&lang=js"

import "./CoursesCarousel.vue?vue&type=style&index=0&id=6d9ae6d3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d9ae6d3"]])

export default __exports__